import ComparisonModularPage from '@/components/pages/compare/ComparisonModularPage';
import ComparisonPage from '@/components/pages/compare/LegacyCompare';
import {
  ComparisonPageQuery,
  ComparisonPageQueryVariables, ComparisonPathsQuery,
} from '@/graphql';
import ComparisonPageQueryDocument from '@/graphql/queries/ComparisonPage.gql';
import ComparisonPathsQueryDocument from '@/graphql/queries/ComparisonPaths.gql';
import { getPageProps } from '@/lib/craft-page';
import CraftClient from '@/lib/graphql';
import { getStaticPagePaths, getStaticPageProps } from '@/lib/next';
import MasterTemplate from '@/templates/MasterTemplate';

const ComparePageHandler: PageTemplate<ComparisonPageQuery> = ({ entry, globals }) => {
  if (!entry) {
    return null
  }

  if (entry && entry?.__typename === 'comparisonPages_modular_Entry') {
    return (<ComparisonModularPage entry={entry} />);
  }

  return (<ComparisonPage entry={entry} globals={globals} />);


};



ComparePageHandler.template = (props: any) => {
  const isModularComparisonPageQueryResult: boolean = !!isModularComparisonPageQuery(props);

  return <MasterTemplate invert={isModularComparisonPageQueryResult} {...props} className={isModularComparisonPageQueryResult ? 'mt-0' : ''} />;
}

export default ComparePageHandler;

const isModularComparisonPageQuery = (obj: any): obj is ComparisonPageQuery => {
  return (
    obj &&
    typeof obj === 'object' &&
    'entry' in obj &&
    obj.entry?.__typename === 'comparisonPages_modular_Entry'
  );
}

export const getStaticProps = getStaticPageProps<{}, { slug: string }>(
  (params) => `compare/${params!.slug}`,
  async ({ client, uri }) => {

    const pageProps = await getPageProps<ComparisonPageQuery, ComparisonPageQueryVariables>({
      pathPrefix: '/compare',
      queryDocument: ComparisonPageQueryDocument,
      client,
      variables: {
        uri,
      },
    });

    if (!pageProps?.entry) {
      return { notFound: true };
    }

    return {
      props: {
        ...pageProps,
      },
    };
  },
);


export const getStaticPaths = getStaticPagePaths('compare', async (context) => {

  const client = new CraftClient();

  const data = await client.request<ComparisonPathsQuery>(ComparisonPathsQueryDocument);

  const paths =
    data.entries?.map((path) => ({
      params: {
        slug: `${path?.slug!}`,
      },
    })) || [];

  return {
    paths,
    fallback: 'blocking',
  };
});
